import { Button, Group } from "@mantine/core";

interface LaborAmendmentActionsBarProps {
  handleCancel: () => void;
  handleSignAndLockClick: () => Promise<void>;
  isSigningAndLocking: boolean;
  isSignAndLockReady: boolean;
  isCancelDisabled?: boolean;
  showCancel?: boolean;
  testIdSuffix?: string;
}

export function LaborAmendmentActionsBar({
  handleCancel,
  handleSignAndLockClick,
  isSigningAndLocking,
  isSignAndLockReady,
  isCancelDisabled = false,
  showCancel = true,
  testIdSuffix,
}: LaborAmendmentActionsBarProps) {
  const testIdInfix = testIdSuffix ? `-${testIdSuffix}` : "";

  return (
    <Group gap="sm" wrap="wrap" justify="flex-end">
      {showCancel ? (
        <Button
          variant="outline"
          onClick={handleCancel}
          data-testid={`labor-amend-cancel${testIdInfix}`}
          disabled={isSigningAndLocking || isCancelDisabled}
        >
          Cancel
        </Button>
      ) : null}
      <Button
        loading={isSigningAndLocking}
        onClick={handleSignAndLockClick}
        disabled={isSigningAndLocking || !isSignAndLockReady}
        data-testid={`labor-amend-sign-and-lock${testIdInfix}`}
      >
        Sign & Lock
      </Button>
    </Group>
  );
}
